import React from "react";
import classnames from "classnames";
import ToolTip from "../tool-tip";
import { connect } from "react-redux";

const IconLicenseBadge = props => {
    let { icon } = props;
    if (!icon) {
        return props.children ? <span>{props.children}</span> : null;
    }
    let { license_description } = icon;

    let license, target, licenseIconClass;

    let containerClass;
    if (icon.license_description === "public-domain") {
        licenseIconClass = "ui_public-domain";
        license = (
            <div>
                <p className="help-body-copy">
                    Public Domain icons can be downloaded and used however you
                    like. And just like a royalty–free purchase, you can edit
                    them.
                </p>
                <a
                    className="text-link"
                    href="https://creativecommons.org/publicdomain/zero/1.0/"
                    target="_blank"
                >
                    Learn more
                </a>
            </div>
        );
    } else {
        // If NounPro
        if (props.download.isPremiumUser) {
            containerClass = "license-royalty-free";
            licenseIconClass = "license-icon license-royalty-free";
            license = (
                <div>
                    <p className="help-body-copy">
                        Downloading this icon with a NounPro account gives you a
                        royalty–free license. The creator of this icon will get
                        a proportion of your subscription.
                    </p>
                    <a
                        className="text-link"
                        href="https://thenounproject.com/accounts/upgrade/"
                        target="_blank"
                    >
                        Learn more
                    </a>
                </div>
            );
        } else if (props.download.hasPurchased) {
            containerClass = "license-royalty-free";
            licenseIconClass = "license-icon license-royalty-free";
            let licenseLink = `/${props.user.username}/settings/icon-history/${
                props.download.pendingDownload.id
            }/`;

            licenseLink = (
                <a className="text-link" href={licenseLink} target="_blank">
                    Learn more
                </a>
            );

            license = (
                <div>
                    <p className="help-body-copy">
                        You have purchased a royalty–free license for this icon.
                    </p>
                </div>
            );
        } else {
            licenseIconClass = "ui_cc";
            // not NounPro
            license = (
                <div>
                    <p className="">
                        This icon is licensed as Creative Commons CCBY
                    </p>
                    <p className="help-body-copy">
                        When using it for any project, you are required to{" "}
                        <a
                            href="https://thenounproject.zendesk.com/hc/en-us/articles/200509928-How-do-I-give-creators-credit-in-my-work-"
                            target="_blank"
                        >
                            give credit to the icon‘s creator
                        </a>{" "}
                        or purchase a royalty–free license.
                    </p>
                    <a
                        className="text-link"
                        href="https://creativecommons.org/licenses/by/3.0/us/legalcode"
                        target="_blank"
                    >
                        Learn more
                    </a>
                </div>
            );
        }
    }

    target = props.children || (
        <span className="hover-context">
            <i className={licenseIconClass} />
        </span>
    );

    containerClass = classnames("icon-license-container", containerClass);
    return (
        <ToolTip target={target} className={containerClass}>
            {license}
        </ToolTip>
    );
};

function mapStateToProps(state, nextProps) {
    let { user, download } = state;

    let icon = download.pendingDownload;

    return {
        user,
        download,
        icon
    };
}

export default connect(mapStateToProps)(IconLicenseBadge);
